export const userKeys = {
  // Planner related queries
  planner: {
    approvers: (techFamilies: string[]) =>
      ['planner', 'approvers', techFamilies] as const,
  },
} as const;
